export class LookupSerializer  {

    public static INSTANCE = new LookupSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeReadAudiences(payload: any) {
        const normalizedAudiences: any = [];
        if (Array.isArray(payload.audience)) {
            payload.audience.map((audience: any) => {
                const audienceData = {
                    label: audience.label,
                    sequence_id: audience.sequence_id,
                    id: audience.id,
                };
                normalizedAudiences.push(audienceData);
            });
        }
        return normalizedAudiences;
    }

    public normalizeLanguage(payload: any) {
        return payload.languages || [];
    }

    public normalizeEducationUse(payload: any) {
        return payload.educational_use || [];
    }

    public normalizeDok(payload: any) {
        return payload.depth_of_knowledge || [];
    }

    public normalizeDefaultLookup(payload: any) {
        return this.extractArrayList(payload);
    }

    public extractArrayList(payload: any) {
        const arrayList = Object.values(payload);
        return arrayList.flat(1);
    }
}

export const lookupSerializer = LookupSerializer.instance;
